@if (!hasPermission) {
  <div class="flex items-center justify-center gap-2 rounded-lg border border-red-200 bg-red-50 p-6 text-sm font-semibold text-red-700">
    <mat-icon class="!text-base text-red-400">lock</mat-icon>
    Permissions Restricted
  </div>
} @else {
  <div class="mb-3 flex items-center justify-between">
    <h3 class="text-secondary text-xs font-semibold uppercase tracking-wide">Subscription Billing</h3>
    @if (data) {
      <a routerLink="/accounting/subscription" class="text-xs font-medium text-blue-600 hover:underline">View all →</a>
    }
  </div>

  @if (loading) {
    <div class="flex justify-center py-6"><mat-spinner diameter="28" /></div>
  }

  @if (error && !loading) {
    <div class="py-3 text-center text-sm text-red-500">{{ error }}</div>
  }

  @if (data && !loading) {
    <!-- Top-line totals -->
    <div class="mb-4 grid grid-cols-3 gap-3">
      <div class="rounded-lg border border-blue-100 bg-blue-50 p-3 text-center">
        <div class="text-sm font-bold text-blue-700" [innerHTML]="data.charge | amount"></div>
        <div class="text-secondary mt-0.5 text-[10px] uppercase tracking-wide">Charges</div>
      </div>
      <div class="rounded-lg border border-red-100 bg-red-50 p-3 text-center">
        <div class="text-sm font-bold text-red-700" [innerHTML]="data.receivables | amount"></div>
        <div class="text-secondary mt-0.5 text-[10px] uppercase tracking-wide">Receivables</div>
      </div>
      <div class="rounded-lg border border-orange-100 bg-orange-50 p-3 text-center">
        <div class="text-xl font-bold text-orange-700">{{ data.overdue_count ?? 0 }}</div>
        <div class="text-secondary mt-0.5 text-[10px] uppercase tracking-wide">Overdue</div>
      </div>
    </div>

    <!-- Per-community breakdown + recent unpaid -->
    <div class="grid grid-cols-1 gap-4 lg:grid-cols-2">
      @if (data.by_community?.length > 0) {
        <div>
          <div class="mb-2 flex items-center gap-2">
            <span class="text-[11px] font-bold uppercase tracking-wider text-gray-400">By Community (<app-currency-symbol></app-currency-symbol>)</span>
            <div class="flex-1 border-t border-gray-100"></div>
          </div>
          <div class="divide-y divide-gray-50">
            @for (c of data.by_community.slice(0, 5); track $index) {
              <div class="flex items-center gap-2 py-1.5 transition-colors hover:bg-gray-50">
                <span class="min-w-0 flex-1 truncate text-xs text-gray-700">{{ c.name }}</span>
                <span class="shrink-0 text-xs font-semibold text-red-600" [innerHTML]="c.balance | amount: false"></span>
              </div>
            }
          </div>
        </div>
      }

      @if (data.recent_unpaid?.length > 0) {
        <div>
          <div class="mb-2 flex items-center gap-2">
            <span class="text-[11px] font-bold uppercase tracking-wider text-gray-400">Recent Unpaid (<app-currency-symbol></app-currency-symbol>)</span>
            <div class="flex-1 border-t border-gray-100"></div>
          </div>
          <div class="space-y-1.5">
            @for (inv of data.recent_unpaid.slice(0, 5); track $index) {
              <div class="flex items-start gap-2 rounded-lg border border-gray-100 bg-gray-50 px-2.5 py-2">
                <div class="min-w-0 flex-1">
                  <p class="text-default truncate text-xs font-medium">{{ inv.community_name ?? '—' }}</p>
                  <p class="text-secondary text-[10px]">{{ inv.reference ?? 'Invoice #' + inv.id }}</p>
                </div>
                <div class="shrink-0 text-right">
                  <p class="text-xs font-semibold text-red-600" [innerHTML]="inv.amount | amount: false"></p>
                  @if (inv.days_overdue > 0) {
                    <p class="text-[10px] text-red-500">{{ inv.days_overdue }}d overdue</p>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }

      @if (!data.by_community?.length && !data.recent_unpaid?.length) {
        <div class="col-span-2 flex flex-col items-center gap-1.5 py-4 text-center">
          <mat-icon class="!text-3xl text-gray-300">receipt_long</mat-icon>
          <span class="text-xs text-gray-400">No outstanding subscription invoices</span>
        </div>
      }
    </div>
  }
}
